export { default } from "./FacebookIcon";
